RECURRENCE_TYPES = ['new', 'active', 'returned', 'cold', 'dead']
# todo i18n
RECURRENCE_LABELS = ['Новые', 'Активные', 'Вернувшиеся', 'Остывшиe', 'Потерянные']
RECURRENCE_COLORS = ['#f15b19', '#f3a113', '#35ade8', '#a855a9', '#686DAD' ]

App.ClientsClientController = Em.Controller.extend
  notifier: Em.inject.service()
  VALIDATABLE_FIELDS: [
    'email',
    'blacklisted_comment'
  ]
  validations: {}

  env: Em.inject.service('environment')
  session: Em.inject.service('session')
  notifier: Em.inject.service()
  needs: ['clients']

  clientBinding: 'model'
  clientTagsBinding: 'controllers.clients.clientTags'

  organizations: Em.computed.alias('session.availableOrganizations')

  multipleOrganizations: Em.computed.gt('organizations.length', 1)

  promos: Ember.computed -> @store.find('promo')

  promosIssues:  Em.computed.filterBy 'promos', 'manual_issue_enabled', true

  currentTab: 'historyTab'
  isHistoryTab: Em.computed.equal('currentTab', 'historyTab')
  isBonusesTab: Em.computed.equal('currentTab', 'bonusesTab')

  extendedBonusBlock: false
  substractBonuses: false
  bonusAmount: null
  activeBonusTransaction: false

  isBonusesEnabled: (->
    isEnabled = false
    @get('session.availableOrganizations').forEach (o) ->
      isEnabled = !!o.get('bonus_enabled')

    isEnabled
  ).property('session.availableOrganizations')

  orderBlocksData: Em.A([])
  orders: null

  # Инициализация orderBlocksData
  onOrdersChanged: (->
    data = @get('orders').map((order) => Em.Object.create({order: order, isOpen: false}))
    @set('orderBlocksData',  Em.A(data))
  ).observes('orders')

  # Вычислимые свойства
  avatarBackground: (->
    return unless @get('client.avatar')
    "background-image: url(#{@get('client.avatar')})".htmlSafe()
  ).property('client')

  regiseteredAt: (->
    moment(@get('client.registered_at')).format('D MMMM YYYY')
  ).property('client.registered_at')

  blacklistedAt: (->
    moment(@get('client.blacklisted_at')).format('D MMMM YYYY')
  ).property('client.blacklisted_at')

  clientRecurrenceType: (->
    @get('env').translate("clients.recurrence_label_long.#{@get('client.recurrence')}")
  ).property('client.recurrence')

  clientRecurrenceComment: (->
    @get('env').translate("clients.recurrence_comment.#{@get('client.recurrence')}")
  ).property('client.recurrence')

  extractValidations: (model, fields) ->
    errors = model.get('errors')
    validations = {}

    fields.forEach (field) =>
      if errors.has(field)
        validations[field] = errors.errorsFor(field).map (m) ->
          m.message
        .join(',')

    errors.clear()
    validations

  teardown: ->
    @set('validations', {})


  ###
  # Параметры графика возвращаемости клиента
  ###

  loadChartData: Ember.on('init', ->
    data = [
      name: 'returnedStatus'
      typeChart: 'line'
      keyFrom: 'dateFrom'
      keyTo: 'dateTo'
      data: [
        level: 1
        dateFrom: moment().subtract(6, 'months').toDate()
        dateTo: moment().subtract(5, 'months').toDate()
        label: "#{moment().subtract(6, 'months').format('D MMMM YYYY')} - #{moment().subtract(5, 'months').format('D MMMM YYYY')}"
      ,
        level: 0
        dateFrom: moment().subtract(5, 'months').toDate()
        dateTo: moment().subtract(3, 'months').toDate()
        label: "#{moment().subtract(5, 'months').format('D MMMM YYYY')} - #{moment().subtract(3, 'months').format('D MMMM YYYY')}"
      ,
        level: 1
        dateFrom: moment().subtract(3, 'months').toDate()
        dateTo: moment().subtract(2, 'months').toDate()
        label: "#{moment().subtract(3, 'months').format('D MMMM YYYY')} - #{moment().subtract(2, 'months').format('D MMMM YYYY')}"
      ,
        level: 2
        dateFrom: moment().subtract(2, 'months').toDate()
        dateTo: moment().subtract(1, 'months').toDate()
        label: "#{moment().subtract(2, 'months').format('D MMMM YYYY')} - #{moment().subtract(1, 'months').format('D MMMM YYYY')}"
      ,
        level: 3
        dateFrom: moment().subtract(1, 'months').toDate()
        dateTo: moment().toDate()
        label: "#{moment().subtract(1, 'months').format('D MMMM YYYY')} - #{moment().format('D MMMM YYYY')}"
      ]
    ,
      name: 'orders'
      typeChart: 'point'
      keyValue: 'created_at'
      data: [
        level: 1
        created_at: moment().subtract(24, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(24, 'months').format('D MMMM YYYY')}"
      ,
        level: 1
        created_at: moment().subtract(22, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(22, 'week').format('D MMMM YYYY')}"
      ,
        level: 0
        created_at: moment().subtract(19, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(19, 'week').format('D MMMM YYYY')}"
      ,
        level: 0
        created_at: moment().subtract(16, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(16, 'week').format('D MMMM YYYY')}"
      ,
        level: 1
        created_at: moment().subtract(10, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(10, 'week').format('D MMMM YYYY')}"
      ,
        level: 2
        created_at: moment().subtract(6, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(6, 'week').format('D MMMM YYYY')}"
      ,
        level: 3
        created_at: moment().subtract(2, 'week').toDate()
        # todo i18n
        label: "Заказ #{moment().subtract(2, 'week').format('D MMMM YYYY')}"
      ]
    ]

    Ember.run.later(@, ->
      @set('chartData', data)
    , 750)
  )

  chartRows: [
    level: 0
    color: RECURRENCE_COLORS[0]
    # todo i18n
    label: 'Aктивный'
  ,
    level: 1
    color: RECURRENCE_COLORS[1]
    # todo i18n
    label: 'Новый / Вернувшийся'
  ,
    level: 2
    color: RECURRENCE_COLORS[2]
    # todo i18n
    label: 'Остывший'
  ,
    level: 3
    color: RECURRENCE_COLORS[3]
    # todo i18n
    label: 'Мертвый'
  ]

  chartData: null

  bonusLogs: []

  page: 1
  pageCount: 1
  perPage: 25
  isLoading: false
  processingRequests: 0

  fetchBonusPortion: ->
    new Em.RSVP.Promise (resolve, reject) =>
      page         = @get('page')
      perPage      = @get('perPage')

      @set('isLoading', true)
      @set('processingRequests', @get('processingRequests') + 1)

      @get('client').nonRESTAction('GET', "bonus_log?page=#{page}&per_page=#{perPage}")
      .then (bonuses) =>
        @set('processingRequests', @get('processingRequests') - 1)

        meta = bonuses.meta
        @setProperties
          page: meta.page
          pageCount: meta.page_count

        resolve(bonuses)
      .catch(reject)
      .finally =>
        @set('isLoading', false)

  loadBonusLogs: (->
    @set('bonusLogs', [])
    @fetchBonusPortion().then (data) =>
      @get('bonusLogs').pushObjects(data.bonus_log)
  ).observes('client')


  loadMoreBonusLogs: (->
    return if Ember.isEmpty(@get('loadBonusLogs'))
    return if @get('isLoading')
    return if @get('page') >= @get('pageCount')
    @incrementProperty('page')
    @fetchBonusPortion().then (data) =>
      @get('bonusLogs').pushObjects(data.bonus_log)
  )

  ###
  # События
  ###
  actions:
    createNewOrder: ->
      client_id = @get('client.id')
      @transitionToRoute('orders.create', queryParams: { client_id })

      false

    createOrderWithinOrganization: (organization)->
      client_id = @get('client.id')
      @transitionToRoute('orders.create', queryParams: { client_id, organization_id: organization.id })

      false

    issuePromo: (promo, button) ->
      return unless confirm("Выдать промокод к акции «#{promo.get('name')}»?")
      button.set 'isLoading', true
      promo.issue(@get('client.id'))
        .then =>
          # todo i18n
          @get('notifier').pushNotification
            type:     'success'
            title:    'Готово'
            message:  'Промокод к акции отправлен клиенту.'
        .catch =>
          # todo i18n
          @get('notifier').pushNotification
            type:     'error'
            title:    'Ошибка'
            message: 'Не удалось создать или отправить промокод клиенту.'
        .finally =>
          button.set 'isLoading', false

    acceptChanges: ->
      @set('isSaving', true)
      client = @get('client')
      client.save()
      .then =>
        @transitionToRoute('clients')
      .catch =>
        false
      .finally =>
        @set('validations', @extractValidations(client, @VALIDATABLE_FIELDS))
        @set('isSaving', false)
      false

    delete: ->
      # todo i18n
      if confirm 'Удалить клиента?'
        client = @get('client')

        client.destroyRecord()
        .then =>
          @controllerFor('clients')?.get('clients')?.removeObject(client)
          @transitionToRoute('clients')
      false

    discardChanges: ->
      @get('client').rollback()
      @get('client.client_tags').clear()
      @get('initialClientTags').forEach (tag) =>
        @get('client.client_tags').pushObject(tag)
      @transitionToRoute('clients')
      false

    toggleOrderBlock: (orderId) ->
      @get('orderBlocksData').forEach (obj) => if obj.order.get('id') != orderId then obj.set('isOpen', false)
      dataItem = @get('orderBlocksData').find((obj) => obj.order.get('id') == orderId)
      dataItem.toggleProperty('isOpen')
      false

    # ClientTag actions
    onRemoveClientTag: (clientTag) ->
      @get('client.client_tags').removeObject(clientTag)

    onAddClientTag: (clientTag) ->
      @get('client.client_tags').addObject(clientTag)

    onAddAndCreateTag: (tagName) ->
      tag = @store.createRecord 'client_tag',
        name: tagName
        organization: @get('session.currentOrganization')
      tag.save()
      @get('client.client_tags').addObject(tag)

    toggleBonusBlock: ->
      @toggleProperty('extendedBonusBlock')
      false

    changeBonusAmount: ->
      amount = Math.abs(parseInt(@get('bonusAmount')))
      return unless amount
      return unless confirm("#{Em.I18n.t 'client_edit.form.bonuses.confirm_transaction'}")

      @set('activeBonusTransaction', true)
      amount = -amount if @get('substractBonuses')
      client = @get('client')
      client.nonRESTAction('PUT', 'commit_bonus_amount', {amount: amount})
      .then =>
        @set('bonusAmount', null)
        client.reload()
        @loadBonusLogs()
      .finally =>
        @set('activeBonusTransaction', false)

    loadMore: ->
      @loadMoreBonusLogs()
      false

